function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".imgBox2_svg__cls-1{fill:#bde0f7}.imgBox2_svg__cls-2{fill:#204e86}.imgBox2_svg__cls-3{fill:#337ac8}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-1",
  d: "M88.86 154.02l-44.45-25.7-.03 51.34 44.48-25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-2",
  d: "M133.34 128.38l-44.45-25.7-.03 51.34 44.48-25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-3",
  d: "M44.41 128.32l44.45 25.7.03-51.34-44.48 25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-2",
  d: "M133.37 77.04l44.44 25.7.04-51.34-44.48 25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-1",
  d: "M88.92 51.34l44.45 25.7.03-51.34-44.48 25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-3",
  d: "M177.85 51.4L133.4 25.7l-.03 51.34 44.48-25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-2",
  d: "M44.48 25.64l44.44 25.7L88.96 0 44.48 25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-1",
  d: "M0 51.28l44.45 25.7.03-51.34L0 51.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-3",
  d: "M88.92 51.34l-44.44-25.7-.03 51.34 44.47-25.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "imgBox2_svg__cls-1",
  d: "M133.34 128.38l44.44 25.7.03-51.34-44.47 25.64z"
})));

function SvgImgBox2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 177.85 179.66"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNzcuODUgMTc5LjY2Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2JkZTBmNzt9LmNscy0ye2ZpbGw6IzIwNGU4Njt9LmNscy0ze2ZpbGw6IzMzN2FjODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDM8L3RpdGxlPjxnIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9Ijg4Ljg2IDE1NC4wMiA0NC40MSAxMjguMzIgNDQuMzggMTc5LjY2IDg4Ljg2IDE1NC4wMiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxMzMuMzQgMTI4LjM4IDg4Ljg5IDEwMi42OCA4OC44NiAxNTQuMDIgMTMzLjM0IDEyOC4zOCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMyIgcG9pbnRzPSI0NC40MSAxMjguMzIgODguODYgMTU0LjAyIDg4Ljg5IDEwMi42OCA0NC40MSAxMjguMzIiLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMTMzLjM3IDc3LjA0IDE3Ny44MSAxMDIuNzQgMTc3Ljg1IDUxLjQgMTMzLjM3IDc3LjA0Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9Ijg4LjkyIDUxLjM0IDEzMy4zNyA3Ny4wNCAxMzMuNCAyNS43IDg4LjkyIDUxLjM0Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjE3Ny44NSA1MS40IDEzMy40IDI1LjcgMTMzLjM3IDc3LjA0IDE3Ny44NSA1MS40Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjQ0LjQ4IDI1LjY0IDg4LjkyIDUxLjM0IDg4Ljk2IDAgNDQuNDggMjUuNjQiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMCA1MS4yOCA0NC40NSA3Ni45OCA0NC40OCAyNS42NCAwIDUxLjI4Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9Ijg4LjkyIDUxLjM0IDQ0LjQ4IDI1LjY0IDQ0LjQ1IDc2Ljk4IDg4LjkyIDUxLjM0Ii8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjEzMy4zNCAxMjguMzggMTc3Ljc4IDE1NC4wOCAxNzcuODEgMTAyLjc0IDEzMy4zNCAxMjguMzgiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgImgBox2 as ReactComponent };